const fullAngle = 2 * Math.PI;

export const FRONT_SIDE = "front";
export const BACK_SIDE = "back";
export const LEFT_SIDE = "left";
export const RIGHT_SIDE = "right";

export default {
  k1: {
    name: "K1 Stationary",
    description: "The Award Winning Machine",
    groupName: "Final-Light1",
    detailsUrl: "https://www.knightscope.com/k1",
    copy:
      "The Knightscope K1 is a stationary machine with the same features you’ve come to expect from the K3 and K5, but optimized for use in smaller areas or at points of ingress and egress – and, of course, it runs 24/7. Suitable for outdoor or indoor environments with remote monitoring from anywhere utilizing our state-of-the-art KSOC user interface. It is a simple installation by Knightscope and can be branded with custom graphics.",
    descriptionPromo:
      "Glossy white paint is standard on the K1 with custom colors available at an additional charge.",
    promo: require("../../assets/models/k1-promo.png"),
    controlTarget: 0.6,
    specs: {
      speed: 0,
      terrain: "Indoor & Outdoor",
      weight: 150,
      dimensions: "28.8” × 69” × 11.2”",
    },
    scale: 0.0077,
    mesh: require("../../assets/models/k1.glb"),
    texture: require("../../assets/models/k1-texture.jpg"),
    textureTransparent: require("../../assets/models/k1-texture-transparent.png"),
    textureSize: {
      width: 2048,
      height: 2048,
    },
    shadowSize: 2,
    envMap: require("../../assets/models/env-map.png"),
    initialMap: [
      {
        name: " K1-Final-Light1",
        color: "111111",
        canWrap: true,
      },
      {
        name: "K1-Final-Light1_1",
        color: "111111",
        canWrap: false,
      },
      {
        name: "K1-Final-Light1_2",
        color: "ffffff",
        canWrap: false,
        isStandardMaterial: true,
      },
      {
        name: "K1-Final-Light1_3",
        color: "555555",
        canWrap: false,
      },
      {
        name: "K1-Final-Light1_4",
        color: "111111",
        canWrap: false,
      },
      {
        name: "K1-Final-Light1_5",
        color: "f3f3f3",
        canWrap: true,
      },
      {
        name: "K1-Final-Light1_8",
        color: "000000",
        canWrap: false,
      },
      {
        name: "K1-Final-Light1_9",
        color: "f3f3f3",
        canWrap: true,
      },
      {
        name: "K1-Final-Light1_10",
        color: "f3f3f3",
        canWrap: true,
      },
      {
        name: "K1-Final-Light1_11",
        color: "f3f3f3",
        canWrap: true,
      },
      {
        name: "K1-Final-Light1_12",
        color: "f3f3f3",
        canWrap: true,
      },
    ],
    sides: {
      [FRONT_SIDE]: {
        index: 0,
        name: "Back",
        rotation: -Math.PI / 4,
        camera: 6,
        element: "K1-Final-Light1_12",
        canEdit: true,
        logos: [
          {
            name: "Back Bottom",

            coords: { x: 1515, y: 1630, width: 375, height: 180 },
          },
          {
            name: "Back Top Left",

            coords: { x: 1492, y: 415, width: 90, height: 60 },
          },
          {
            name: "Back Top Right",
            coords: { x: 1820, y: 415, width: 90, height: 60 },
          },
        ],
      },
      [LEFT_SIDE]: {
        index: 1,
        name: "Left",
        rotation: -Math.PI,
        camera: 6,
        element: "K1-Final-Light1_9",
        canEdit: true,
        logos: [
          {
            name: "Left Side Bottom",
            coords: { x: 1127, y: 1107, width: 160, height: 580 },
          },
        ],
      },
      [BACK_SIDE]: {
        index: 2,
        name: "Front",
        rotation: (Math.PI * 3) / 4,
        camera: 6,
        element: "K1-Final-Light1_11",
        canEdit: true,
        logos: [
          {
            name: "Front Bottom",
            coords: { x: 155, y: 1630, width: 375, height: 180 },
          },
          {
            name: "Front Top Left",
            coords: { x: 135, y: 415, width: 90, height: 60 },
          },
          {
            name: "Front Top Right",
            coords: { x: 470, y: 415, width: 90, height: 60 },
          },
        ],
      },
      [RIGHT_SIDE]: {
        index: 3,
        name: "Right",
        rotation: 0,
        camera: 6,
        element: "K1-Final-Light1_10",
        canEdit: true,
        logos: [
          {
            name: "Right Side Bottom",
            coords: { x: 765, y: 1107, width: 160, height: 580 },
          },
        ],
      },
    },
  },
  k3: {
    name: "K3 Indoor",
    detailsUrl: "https://www.knightscope.com/k3",
    description: "Compact Yet Capable",
    promo: require("../../assets/models/k3-promo.png"),
    copy:
      "The Knightscope K3 is a stationary machine with the same features you’ve come to expect from the K3 and K5, but optimized for use in smaller areas or at points of ingress and egress – and, of course, it runs 24/7. Suitable for outdoor or indoor environments with remote monitoring from anywhere utilizing our state-of-the-art KSOC user interface. It is a simple installation by Knightscope and can be branded with custom graphics.",
    descriptionPromo:
      "The K3 comes standard with matte black sides and a glossy white shell running from front to rear.",
    specs: {
      speed: 3,
      terrain: "Indoor",
      weight: 340,
      dimensions: "24” × 51” × 33”",
    },
    controlTarget: 0.45,
    scale: 0.0081,
    mesh: require("../../assets/models/k3-2.glb"),
    texture: require("../../assets/models/k3-texture.jpg"),
    textureTransparent: require("../../assets/models/k3-texture-transparent.png"),
    textureSize: {
      width: 2048,
      height: 2048,
    },
    shadowSize: 3,
    envMap: require("../../assets/models/env-map.png"),
    initialMap: [
      {
        name: "K3-DetailUpdate_1",
        color: "111111",
        canWrap: false,
      },
      {
        name: "K3-DetailUpdate_2",
        color: "f3f3f3",
        canWrap: false,
      },
      {
        name: "K3-DetailUpdate_3",
        color: "f3f3f3",
        canWrap: false,
      },
      {
        name: "K3-DetailUpdate_4",
        color: "111111",
        canWrap: false,
      },
      {
        name: "K3-DetailUpdate_5",
        color: "4D90EB",
        canWrap: false,
      },
      {
        name: "K3-DetailUpdate_6",
        color: "f3f3f3",
        canWrap: false,
        isStandardMaterial: true,
      },
      {
        name: "K3-DetailUpdate_7",
        color: "222222",
        canWrap: false,
      },
      {
        name: "K3-DetailUpdate_8",
        color: "111111",
        canWrap: false,
      },
      {
        name: "K3-DetailUpdate_9",
        color: "f3f3f3",
        canWrap: true,
      },
      {
        name: "K3-DetailUpdate_10",
        color: "f3f3f3",
        canWrap: true,
        syncWithElement: "K3-DetailUpdate_9",
      },
      {
        name: "K3-DetailUpdate_11",
        color: "111111",
        canWrap: false,
      },
      {
        name: "K3-DetailUpdate_12",
        color: "222222",
        canWrap: false,
        // This flag overrides canWrap behavior for cloned geometries
        canCloneWrap: true,
      },
      {
        name: "K3-DetailUpdate_13",
        color: "222222",
        canWrap: false,
        // This flag overrides canWrap behavior for cloned geometries
        canCloneWrap: true,
      },
    ],
    sides: {
      [FRONT_SIDE]: {
        index: 0,
        name: "Back",
        rotation: -Math.PI / 3,
        camera: 6,
        element: "K3-DetailUpdate_9",
        syncWithElement: "K3-DetailUpdate_10",
        canEdit: false,
        logos: [
          {
            name: "Back Side Top",
            coords: { x: 980, y: 1340, width: 180, height: 60 },
          },
          {
            name: "Back Side Bottom",
            coords: { x: 975, y: 1488, width: 364, height: 175 },
          },
        ],
      },
      [BACK_SIDE]: {
        index: 2,
        name: "Front",
        rotation: (2 * Math.PI) / 3,
        camera: 6,
        element: "K3-DetailUpdate_10",
        canEdit: true,
        logos: [
          {
            name: "Front Side Top",
            coords: { x: 340, y: 1335, width: 180, height: 60 },
          },
          {
            name: "Front Side Bottom",
            coords: { x: 340, y: 1488, width: 364, height: 175 },
          },
        ],
      },
      [LEFT_SIDE]: {
        index: 1,
        name: "Left",
        rotation: -Math.PI,
        camera: 6,
        element: "K3-DetailUpdate_7",
        canEdit: false,
        enforceHideWrap: true,
        logos: [
          {
            name: "Left Side",
            coords: { x: 1380, y: 205, width: 200, height: 175 },
          },
        ],
      },
      [RIGHT_SIDE]: {
        index: 3,
        name: "Right",
        rotation: 0,
        camera: 6,
        element: "K3-DetailUpdate_7",
        canEdit: false,
        enforceHideWrap: true,
        predefindedColors: [
          {
            name: "White",
            value: "ffffff",
          },
          {
            name: "Black",
            value: "222222",
          },
        ],
        logos: [
          {
            name: "Right Side",
            coords: { x: 480, y: 205, width: 200, height: 175 },
          },
        ],
      },
    },
  },
  k5: {
    name: "K5 Outdoor/Indoor",
    description: "Our Most Popular ASR",
    promo: require("../../assets/models/k5-promo.png"),
    descriptionPromo: "Click this card to learn more about the K5 options.",
    specs: {
      speed: 3,
      terrain: "Outdoor & Indoor",
      weight: 398,
      dimensions: "33.5” × 62.5” × 36”",
    },
    submodels: {
      textured: {
        name: "K5 Ruggedized Paint",
        detailsUrl: "https://www.knightscope.com/k5",
        enableWrap: true,
        description: "Our Most Popular ASR",
        copy:
          "The Knightscope K5 is a stationary machine with the same features you’ve come to expect from the K3 and K5, but optimized for use in smaller areas or at points of ingress and egress – and, of course, it runs 24/7. Suitable for outdoor or indoor environments with remote monitoring from anywhere utilizing our state-of-the-art KSOC user interface. It is a simple installation by Knightscope and can be branded with custom graphics.",
        promo: require("../../assets/models/k5-promo.png"),
        descriptionPromo:
          "Ruggedized paint is standard on a K5 – it is a heavy duty, textured paint similar to automotive bedliner.",
        specs: {
          speed: 3,
          terrain: "Outdoor & Indoor",
          weight: 398,
          dimensions: "33.5” × 62.5” × 36”",
        },
        controlTarget: 0.6,
        scale: 0.0079,
        mesh: require("../../assets/models/k5-alt-new.glb"),
        texture: require("../../assets/models/k5-alt-texture.jpg"),
        textureTransparent: require("../../assets/models/k5-alt-texture-transparent.png"),
        altTexture: require("../../assets/models/k5-alt-head.jpg"),
        textureSize: {
          width: 2048,
          height: 2048,
        },
        envMap: require("../../assets/models/env-map.png"),
        shadowSize: 3,
        sides: {
          [FRONT_SIDE]: {
            index: 0,
            name: "Back",
            rotation: -Math.PI / 3,
            camera: 6,
            element: "K5TextureUpdate4_6",
            canEdit: true,
            enforceHideWrap: true,
            logos: [
              {
                name: "Back Side",
                coords: { x: 1475, y: 1518, width: 372, height: 84 },
              },
            ],
          },
          [BACK_SIDE]: {
            index: 2,
            name: "Front",
            rotation: (2 * Math.PI) / 3,
            camera: 6,
            element: "K5Texture_Final_6",
            canEdit: false,
            enforceHideWrap: true,
            logos: [
              {
                name: "Front Side",
                coords: { x: 578, y: 1518, width: 372, height: 84 },
              },
            ],
          },
          [LEFT_SIDE]: {
            index: 1,
            name: "Left",
            rotation: -Math.PI,
            camera: 6,
            element: "K5Texture_Final_3",
            canEdit: false,
            enforceHideWrap: true,
            logos: [
              {
                name: "Left Side",
                coords: { x: 112, y: 1518, width: 377, height: 291 },
              },
            ],
          },
          [RIGHT_SIDE]: {
            index: 3,
            name: "Right",
            rotation: 0,
            camera: 6,
            element: "K5Texture_Final_9",
            canEdit: false,
            enforceHideWrap: true,
            logos: [
              {
                name: "Right Side",
                coords: { x: 1024, y: 1518, width: 377, height: 291 },
              },
            ],
          },
        },
        initialMap: [
          {
            name: "K5TextureUpdate4_1",
            color: "f3f3f3",
            canWrap: true,
          },
          {
            name: "K5TextureUpdate4_2",
            color: "f3f3f3",
            canWrap: false,
          },
          {
            name: "K5TextureUpdate4_3",
            color: "f3f3f3",
            canWrap: false,
          },
          {
            name: "K5TextureUpdate4_4",
            color: "f3f3f3",
            canWrap: true,
          },
          {
            name: "K5TextureUpdate4_5",
            color: "f3f3f3",
            canWrap: true,
          },
          {
            name: "K5TextureUpdate4_6",
            color: "ff0000",
            canWrap: false,
          },
          {
            name: "K5TextureUpdate4_7",
            color: "dddddd",
            canWrap: false,
          },
          {
            name: "K5TextureUpdate4_8",
            color: "eeeeee",
            canWrap: false,
            isStandardMaterial: true,
          },
          {
            name: "K5TextureUpdate4_9",
            color: "f3f3f3",
            canWrap: false,
            isStandardMaterial: true,
          },
          {
            name: "K5TextureUpdate4_10",
            color: "222222",
            canWrap: false,
          },
          {
            name: "K5TextureUpdate4_11",
            color: "000000",
            canWrap: false,
          },
          {
            name: "K5TextureUpdate4_12",
            color: "dddddd",
            canWrap: false,
          },
          {
            name: "K5TextureUpdate4_13",
            color: "4D90EB",
            canWrap: false,
          },
        ],
      },
      glossy: {
        name: "K5 Glossy Paint",
        detailsUrl: "https://www.knightscope.com/k5",
        description: "Our Most Popular ASR",
        copy:
          "The Knightscope K5 is primarily an outdoor machine which runs 24/7 on its own including autonomously recharging itself without any human intervention.  It is best suited for securing large outdoor spaces.  We have operated nearly 1 million hours in the field and now well into our 3rd winter.  Working together with human eyes utilizing our fully integrated Knightscope Security Operations Center browser-based user interface, you now have an actual force multiplier physical deterrence. This means a tremendous amount of real-time data can be used to better secure the places people work, study, and visit.",
        promo: require("../../assets/models/k5-promo-glossy.png"),
        descriptionPromo:
          "Glossy paint is available as an upgrade on the K5 and may be custom-colored to match your brand.",
        specs: {
          speed: 3,
          terrain: "Outdoor & Indoor",
          weight: 398,
          dimensions: "33.5” × 62.5” × 36”",
        },
        controlTarget: 0.6,
        scale: 0.0079,
        mesh: require("../../assets/models/k5.glb"),
        texture: require("../../assets/models/k5-texture.jpg"),
        textureTransparent: require("../../assets/models/k5-texture-transparent.png"),
        altTexture: require("../../assets/models/k5-head-stickers.jpg"),
        textureSize: {
          width: 2048,
          height: 2048,
        },
        shadowSize: 3,
        envMap: require("../../assets/models/env-map.png"),
        sides: {
          [FRONT_SIDE]: {
            index: 0,
            name: "Back",
            rotation: -Math.PI / 3,
            camera: 6,
            canEdit: true,
            element: "K5Glossy-FinalOBJ_4",
            logos: [
              {
                name: "Back Side Top",
                coords: { x: 284, y: 280, width: 512, height: 152 },
              },
              {
                name: "Back Side Bottom",
                coords: { x: 284, y: 567, width: 478, height: 110 },
              },
            ],
          },
          [BACK_SIDE]: {
            index: 2,
            name: "Front",
            rotation: (2 * Math.PI) / 3,
            camera: 6,
            canEdit: true,
            element: "K5Glossy-FinalOBJ_6",
            logos: [
              {
                name: "Front Side Top",
                coords: { x: 229, y: 1280, width: 512, height: 110 },
              },
              {
                name: "Front Side Bottom",
                coords: { x: 229, y: 1578, width: 478, height: 110 },
              },
            ],
          },
          [LEFT_SIDE]: {
            index: 1,
            name: "Left",
            rotation: -Math.PI,
            camera: 6,
            canEdit: true,
            element: "K5Glossy-FinalOBJ_3",
            logos: [
              {
                name: "Left Side",
                coords: { x: 1308, y: 255, width: 455, height: 455 },
              },
            ],
          },
          [RIGHT_SIDE]: {
            index: 3,
            name: "Right",
            rotation: 0,
            camera: 6,
            canEdit: true,
            element: "K5Glossy-FinalOBJ_1",
            logos: [
              {
                name: "Right Side",
                coords: { x: 1323, y: 1240, width: 455, height: 455 },
              },
            ],
          },
        },
        initialMap: [
          {
            name: "K5Glossy-FinalOBJ_1",
            color: "f3f3f3",
            canWrap: true,
          },
          {
            name: "K5Glossy-FinalOBJ_2",
            color: "f3f3f3",
            canWrap: true,
          },
          {
            name: "K5Glossy-FinalOBJ_3",
            color: "f3f3f3",
            canWrap: true,
          },
          {
            name: "K5Glossy-FinalOBJ_4",
            color: "f3f3f3",
            canWrap: true,
          },
          {
            name: "K5Glossy-FinalOBJ_5",
            color: "dddddd",
            canWrap: false,
          },
          {
            name: "K5Glossy-FinalOBJ_6",
            color: "f3f3f3",
            canWrap: true,
          },
          {
            name: "K5Glossy-FinalOBJ_7",
            color: "f3f3f3",
            canWrap: false,
          },
          {
            name: "K5Glossy-FinalOBJ_8",
            color: "111111",
            canWrap: false,
          },
          {
            name: "K5Glossy-FinalOBJ_9",
            color: "222222",
            canWrap: false,
          },
          {
            name: "K5Glossy-FinalOBJ_10",
            color: "f3f3f3",
            canWrap: false,
            isStandardMaterial: true,
          },
          {
            name: "K5Glossy-FinalOBJ_12",
            color: "cccccc",
            canWrap: false,
          },
          {
            name: "K5Glossy-FinalOBJ_13",
            color: "111111",
            canWrap: false,
          },
          {
            name: "K5Glossy-FinalOBJ_11",
            color: "4D90EB",
            isStandardMaterial: true,
            canWrap: false,
          },
        ],
      },
    },
  },
};
